import { useIntl } from "react-intl";
import { WmButton } from "@watermarkinsights/ripple-react";

export function DraftPanelHeader({
  isDraftResultView,
  onBackToConversation,
  onBackToSelection,
  onClose,
}: {
  isDraftResultView: boolean;
  onBackToConversation: () => void;
  onBackToSelection: () => void;
  onClose: () => void;
}) {
  const intl = useIntl();

  return (
    <div className="tcw-header-row">
      <WmButton
        button-type="navigational"
        icon="#back"
        className="tcw-back-btn"
        tooltip={intl.formatMessage({ id: "app.toolboxChat.action.back" })}
        onClick={isDraftResultView ? onBackToSelection : onBackToConversation}
      />
      <div className="tcw-header-text">
        <div className="tcw-breadcrumb-row">
          <p className="tcw-breadcrumb">
            <button
              type="button"
              className="tcw-breadcrumb__link"
              onClick={onBackToConversation}
            >
              {intl.formatMessage({
                id: "app.toolboxChat.draftConversation.breadcrumbConversation",
              })}
            </button>
            <span className="tcw-breadcrumb__separator" aria-hidden="true">
              ›
            </span>
            {isDraftResultView ? (
              <button
                type="button"
                className="tcw-breadcrumb__link"
                onClick={onBackToSelection}
              >
                {intl.formatMessage({
                  id: "app.toolboxChat.draftConversation.breadcrumbDraftMessage",
                })}
              </button>
            ) : (
              <span className="tcw-breadcrumb__current" aria-current="step">
                {intl.formatMessage({
                  id: "app.toolboxChat.draftConversation.breadcrumbDraftMessage",
                })}
              </span>
            )}
            {isDraftResultView && (
              <>
                <span className="tcw-breadcrumb__separator" aria-hidden="true">
                  ›
                </span>
                <span className="tcw-breadcrumb__current" aria-current="step">
                  {intl.formatMessage({
                    id: "app.toolboxChat.draftConversation.breadcrumbCopyMessage",
                  })}
                </span>
              </>
            )}
          </p>
        </div>
        <h2 className="tcw-header-title tcw-header-title--draft">
          {intl.formatMessage({
            id: isDraftResultView
              ? "app.toolboxChat.draftConversation.titleCopyMessage"
              : "app.toolboxChat.draftConversation.title",
          })}
        </h2>
      </div>
      <WmButton
        button-type="navigational"
        icon="#close"
        className="tcw-header-close-btn"
        tooltip={intl.formatMessage({ id: "app.toolboxChat.action.close" })}
        onClick={onClose}
      />
    </div>
  );
}
